<div
  [ngClass]="cssClass()"
  class="inline-flex text-sm font-bold uppercase">
  {{ type() | adminSubscriptionOrderType | async }}
</div>
